module.exports = __webpack_public_path__ + "img/whatsapp.44175b9d.png";